import { render, staticRenderFns } from "./youthlearn.vue?vue&type=template&id=dba577b0&scoped=true&"
import script from "./youthlearn.vue?vue&type=script&lang=js&"
export * from "./youthlearn.vue?vue&type=script&lang=js&"
import style0 from "./youthlearn.vue?vue&type=style&index=0&id=dba577b0&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba577b0",
  null
  
)

export default component.exports